module.exports = __webpack_public_path__ + "static/media/fondo_produccion_audiovisual.90e492fc.jpg";